window.addEventListener('load', async () => {
    if (navigator.serviceWorker) {
        // registration for search
        try {
            await navigator.serviceWorker.register('/service-worker.js');
        } catch (error) {
            if (error instanceof Error) {
                console.error(
                    `Registration service-worker failed with ${error}`
                );
            }
        }
    } else {
        console.error('Service workers are not supported.');
    }
});

// TS1208: 'service-workers.ts' cannot be compiled under '--isolatedModules' because it is considered a global script file.
// Add an import, export, or an empty 'export {}' statement to make it a module.
export {};
